import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  WritableSignal,
  signal,
  inject,
} from '@angular/core';
import { ToggleEvent } from '@shared/abstraction/toggle/toggle-events';
import { CurrentUserService } from '@shared/services';
import { UserSettingsService } from '@shared/services/user-settings.service';
import {
  UserEmailNotificationSettingsRequest,
  UserEmailNotificationSettingsResponse,
} from 'src/app/web-api-client';

@Component({
  standalone: false,
  selector: 'gstar-settings-panel',
  templateUrl: './settings-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPanelComponent implements OnInit {
  private currentUserService = inject(CurrentUserService);
  private userSettingsService = inject(UserSettingsService);

  toggleStatus: WritableSignal<boolean> = signal<boolean>(false);

  ngOnInit(): void {
    this.userSettingsService
      .getEmailConfigurationById(
        this.currentUserService.currentUserInfo()?.userId as string
      )
      .subscribe(
        (notificationSetting: UserEmailNotificationSettingsResponse) => {
          this.toggleStatus.set(
            notificationSetting.notificationEmailsEnabled as boolean
          );
        }
      );
  }

  changeConfiguration(event: ToggleEvent): void {
    const config = new UserEmailNotificationSettingsRequest({
      userId: this.currentUserService.currentUserInfo()?.userId as string,
      notificationEmailsEnabled: event.switchState,
    });
    this.userSettingsService
      .setEmailConfiguration(
        this.currentUserService.currentUserInfo()?.userId as string,
        config
      )
      .subscribe();
  }
}
